import React from "react";
import Input from "../../../SharableInputs/Input";
import CustomSingleSelect from "../../../SharableInputs/CustomSingleSelect";

const FIELD_LABEL_OVERRIDES = {
  ssn: "Employee Social Security Number",
  case_creator_name: "Case Creator Name",
  case_creator_email_address: "Case Creator Email",
  case_creator_phone_number: "Case Creator Phone Number",
  case_creator_phone_number_extension: "Case Creator Phone Extension",
  document_a_type_code: "Document A Type",
  document_b_type_code: "Document B Type",
  document_c_type_code: "Document C Type",
  document_bc_number: "Document B/C Number",
  document_sub_type_code: "Document Sub Type",
  us_state_code: "U.S. State Code",
  country_code: "Country Code",
  reason_for_delay_code: "Reason for Delay",
  reason_for_delay_description: "Delay Description",
  employee_address1: "Employee Address 1",
  employee_address2: "Employee Address 2",
  employee_city: "Employee City",
  employee_state: "Employee State",
  employee_zip_code: "Employee ZIP Code",
  employee_email_address: "Employee Email Address",
  phone_number: "Phone Number",
  middle_initial: "Middle Initial"
};

const formatFieldLabel = (fieldName = "") => {
  if (FIELD_LABEL_OVERRIDES[fieldName]) return FIELD_LABEL_OVERRIDES[fieldName];
  return fieldName
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const resolveInputType = (fieldName = "") => {
  if (fieldName.includes("date")) return "date";
  if (fieldName.includes("email")) return "email";
  if (fieldName.includes("phone")) return "tel";
  if (fieldName.includes("zip")) return "text";
  if (fieldName.includes("ssn")) return "text";
  return "text";
};

const CaseFieldsStep = ({
  caseFields,
  caseFieldValues,
  onFieldChange,
  dropdownOptionMap = {},
  isDelayExplanationRequired = false,
  forcedRequiredFields
}) => {
  if (!caseFields.length) {
    return (
      <div className="step-content case-fields-step">
        <h2 className="page-title mb-4">E-verify Case Details</h2>
        <p>No additional fields are required for this selection.</p>
      </div>
    );
  }

  return (
    <div className="step-content case-fields-step">
      <h2 className="page-title mb-4">E-verify Case Details</h2>
      <div className="row g-4 case-grid">
        {caseFields.map(field => {
          const fieldName = field.field_Name;
          const label = formatFieldLabel(fieldName);
          const dropdownOptions = dropdownOptionMap[fieldName];
          const requiresDelayInfo =
            ["reason_for_delay_code", "reason_for_delay_description"].includes(fieldName) &&
            isDelayExplanationRequired;
          const isForceRequired =
            forcedRequiredFields?.has?.(fieldName) ||
            (Array.isArray(forcedRequiredFields) && forcedRequiredFields.includes(fieldName));
          const isRequired = field.required || requiresDelayInfo || isForceRequired;

          if (dropdownOptions) {
            const selectedOption =
              dropdownOptions.find(option => option.value === caseFieldValues[fieldName]) || null;
            return (
              <div className="col-md-6 field-item" key={fieldName}>
                <CustomSingleSelect
                  label={
                    <>
                      {label}
                      {isRequired && <span className="required-asterisk">*</span>}
                    </>
                  }
                  name={fieldName}
                  selectedValue={selectedOption}
                  onChange={(option) => onFieldChange(fieldName, option?.value || "")}
                  options={dropdownOptions}
                  placeholder={`Select ${label}`}
                  className="document-select"
                />
              </div>
            );
          }

          return (
            <div className="col-md-6 field-item" key={fieldName}>
              <Input
                label={
                  <>
                    {label}
                    {isRequired && <span className="required-asterisk">*</span>}
                  </>
                }
                name={fieldName}
                value={caseFieldValues[fieldName] || ""}
                onChange={(e) => onFieldChange(fieldName, e.target.value)}
                placeholder={`Enter ${label}`}
                type={resolveInputType(fieldName)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CaseFieldsStep;
